export enum CustomRoles{
    CABAdmin = 5,
    CABCommunicator = 6,
    CertificateManagement = 7,
    Accountant = 4,
}
